import clsx from 'clsx';
import { ReactNode, useId } from 'react';
import { ControllerRenderProps, FieldValues } from 'react-hook-form';
import { Icon } from '../../components/Icon/Icon';
import { Tooltip } from '../../components/Tooltip/Tooltip';
import { prepareLabel } from '../prepare-label';
import s from './InputLabel.module.scss';

interface InputLabelProps {
    field?: ControllerRenderProps<FieldValues, string>;
    labelHidden?: boolean;
    label?: string;
    id?: string;
    labelClassName?: string;
    labelTooltip?: string;
    horizontal?: boolean;
    required?: boolean;
    suppressRequiredLabel?: boolean;
    bulkMode?: boolean;
}

export function InputLabel({
    id,
    labelHidden,
    horizontal,
    labelClassName: labelClassNameProps,
    labelTooltip,
    label,
    field,
    required,
    suppressRequiredLabel,
    bulkMode,
}: InputLabelProps): ReactNode {
    const reactId = useId();

    if (labelHidden) {
        return null;
    }

    // React 18 ids contain ':' which is not valid in a '#id' CSS selector.
    const infoIconId = `input-label-info-${reactId.replace(/:/g, '')}`;

    const labelClassName = clsx(
        labelClassNameProps,
        horizontal ? s.label : null,
        'flex gap-2',
    );
    return (
        <label htmlFor={id || field?.name} className={labelClassName}>
            {prepareLabel(
                field?.name,
                label,
                suppressRequiredLabel ? false : required,
                bulkMode,
            )}
            {labelTooltip ? (
                <>
                    <Icon id={infoIconId} name="info" />
                    <Tooltip target={`#${infoIconId}`}>{labelTooltip}</Tooltip>
                </>
            ) : null}
        </label>
    );
}
